export const FETCH_PLAYER_GET_MEDIA_INIT = 'FETCH_PLAYER_GET_MEDIA_INIT';
export const FETCH_PLAYER_GET_MEDIA_SUCCESS = 'FETCH_PLAYER_GET_MEDIA_SUCCESS';
export const FETCH_PLAYER_GET_MEDIA_ERRROR = 'FETCH_PLAYER_GET_MEDIA_ERRROR';
export const FETCH_LIVE_PLAYER_IS_BROKEN = 'FETCH_LIVE_PLAYER_IS_BROKEN';

export const CLEAR_PLAYER_DATA = 'CLEAR_PLAYER_DATA';

export const SET_UNIX_BEGIN = 'SET_UNIX_BEGIN';

export const SET_COUNTER_HBO_ERROR = 'SET_COUNTER_HBO_ERROR';
